// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f65f45e4","732":"81c848cf","977":"fffcc192"}[chunkId] + ".chunk.js";
};